import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Folder, FolderEditOrCreateDTO } from '../services/TemplateService/Template.type';

const useSaveFolder = () => {
  const client = useQueryClient();
  const { mutate: saveFolder, isPending: isSavingFolder } = useMutation({
    mutationFn: ({
      folderConfig,
    }: {
      folderConfig: FolderEditOrCreateDTO;
      onSuccessFunction?: (data: Folder) => void | undefined;
    }) => {
      return BackendService.instance.blueprint.saveFolder(folderConfig);
    },

    onSettled: () => {
      client.invalidateQueries({
        queryKey: ['folders']
      });
    },

    onSuccess: (data, { onSuccessFunction }) => {
      if (onSuccessFunction) {
        onSuccessFunction(data);
      }
    }
  });

  return {
    saveFolder,
    isSavingFolder,
  };
};
export default useSaveFolder;
